import { render, staticRenderFns } from "./InvitationInfo.vue?vue&type=template&id=1f2143e7&scoped=true&"
import script from "./InvitationInfo.vue?vue&type=script&lang=js&"
export * from "./InvitationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2143e7",
  null
  
)

export default component.exports